<template>
  <div class="content">
    <div class="container-fluid">
        <!-- <notification-banner></notification-banner> -->
        <transition name="fade" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </transition>
    </div>
  </div>
</template>
<script>
import NotificationBanner from "../../components/NotificationBanner.vue";
export default {
  components: {
    NotificationBanner
  },
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}

.fade-enter,
  .fade-leave-to
  /* .fade-leave-active in <2.1.8 */

 {
  opacity: 0;
}
</style>
